import { StyledSpacer } from "./Spacer.components.js";
export const SpacerAtomComponent = StyledSpacer;
export default SpacerAtomComponent;
